import addSourceMiddleware from './addSourceMiddleware';
import getUserId from './getUserId';
import identify from './identify';
import page from './page';
import ready from './ready';
import track from './track';
import trackClickEvent from './trackClickEvent';
import trackModuleViewedEvent from './trackModuleViewedEvent';

export {
  addSourceMiddleware,
  track,
  trackClickEvent,
  trackModuleViewedEvent,
  page,
  identify,
  ready,
  getUserId,
};

// Export interfaces for use in other packages
export type { TrackClickEventProperties } from './trackClickEvent';
export type { TrackModuleViewedEventProperties } from './trackModuleViewedEvent';
